import { React } from "react";
import { useParams } from "react-router-dom";
import PSPage from "components/globals/ui/layout/Page"
import { useFetchAuthedData, formatTitle } from "helpers/utils";
import parse from "html-react-parser";
import IsYoursBanner from 'components/globals/IsYoursBanner'
import Comments from "components/globals/comments/Comments";
import Likes from "components/globals/likes/Likes";
import {TypeBadge, CategoryBadge} from "components/globals/ui/TypeBadge";


const EventPage = () => {
	const { id } = useParams();

	// double entry, entry.entry & entry.user
	const { data: entry, loading, error } = useFetchAuthedData(
		`note/${id}`,
		[id],
	);

	// Loading & error states
	if (loading) return <div>Loading...</div>;
	if (error) return <div>Error: {error.message}</div>;

	return (
		<>
			<IsYoursBanner label="Your Note" entry={entry.entry} />

			<PSPage>

				<div className="flex items-start flex-wrap md:flex-nowrap gap-sm mt-sm">

					{entry.entry.gallery.length > 0 && (
						<div className="md:sticky md:top-[100px] w-full md:w-1/2 rounded-default overflow-hidden">
							
								<img
									className='block w-full'
									src={`//ps-images.imgix.net/${entry.entry.gallery[0].filename}?q=85&width=600`}
									alt="baseImage"
								/>		
						</div>
					)}
		

					<div className="w-full md:w-1/2">
						
						<div className="my-1 flex flex-wrap items-center inline-block gap-2">
							<TypeBadge entryType={entry.entry.entry_type} type={entry.entry.type} category={entry.entry.category} />
							<CategoryBadge entryType={entry.entry.entry_type} type={entry.entry.type} category={entry.entry.category} />
						</div>
						
						<h1 className="text-3xl font-bold">{ formatTitle(entry.entry.title) }</h1>
	
						<div>
							<Likes 
								entry_type={entry.entry.entry_type} 
								entry_id={entry.entry.internal_id}
							/>
						</div>

						
						{entry?.entry?.body && (
							<div className="mt-xs mb-md ors-rich-text">{parse(entry?.entry?.body)}</div>
						)}

						<Comments 
							entry_type={entry.entry.entry_type} 
							entry_id={entry.entry.internal_id}
						/>

					</div>
				</div>
			</PSPage>
		</>
		
	);
};

export default EventPage;
